import { FunctionComponent, useEffect, useRef, useState } from "react";
import Table from "../../../../Components/Table/Table";
import CustomToolbar from "../../../../Components/Table/components/CustomToolbar";
import ButtonField from "../../../../Components/Button/ButtonField";
import { Columns } from "../../../../Components/Table/ITable";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { useAppDispatch, useAppSelector } from "../../../../Redux/Store/Hooks";
import TableSearch from "../../../../Components/Table/components/TableSearch";
import IconButtonField from "../../../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import { IDeleteDialog } from "../../../../Components/DeleteDialog/IDeleteDialog";
import { ReactComponent as Edit } from "../../../../Assets/Images/edit.svg";
import { ReactComponent as RefreshButton } from "../../../../Assets/Images/RefreshButton.svg";
import DeleteDialog from "../../../../Components/DeleteDialog/DeleteDialog";
import Dialog from "../../../../Components/Dialog/Dialog";
import ResponseDialog from "../../../../Components/ResponseDialog/ResponseDialog";
import { ReactComponent as Delete } from "../../../../Assets/Images/delete.svg";
import SubjectDriveMapForm from "./SubjectDriveMapForm";
import { ISubjectDriveMap } from "./ISubjectDriveMap";
import { Subject_Drive_MapMasterRead } from "../../../../Redux/Slices/Booklet/Admin/Subject_drive_map/SubjectDriveMapMasterRead";
import { clearSubject_Drive_MapCreate_Update, Subject_Drive_MapCreate_Update } from "../../../../Redux/Slices/Booklet/Admin/Subject_drive_map/SubjectFolderDriveMasterCreate_Update";
import { SubjectFolderMasterRaedCall } from "../../../../Redux/Slices/Booklet/SagaApiCall";



const SubjectDriveMap: FunctionComponent = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
    const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<ISubjectDriveMap | {}>({
    status: true,
  });

  const dispatch = useAppDispatch();
  const formRef = useRef<HTMLFormElement>(null);

  const { data: subjectDriveMapList } = useAppSelector(
    (state) => state.Subject_Drive_MapMasterRead
  );
  const { data: addOrUpdateResponse } = useAppSelector(
    (state) => state.Subject_Drive_MapCreate_Update
  );

  // Columns definition
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "subject_name",
      renderHeader: () => <b>Subject Name</b>,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
{
  field: "drive_folder_link",
  headerName: "Drive Folder Link",
  flex: 2,
  align: "center",
  headerAlign: "center",
  renderCell: (params: GridRenderCellParams<ISubjectDriveMap>) => (
    <a
      href={params.value}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#1976d2",
        textDecoration: "underline",
        whiteSpace: "normal",   // allows wrapping
        wordBreak: "break-all", // breaks long links nicely
        display: "inline-block",
        maxWidth: "100%",       // keeps within column width
        textAlign: "center",
      }}
    >
      {params.value}
    </a>
  ),
},

    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      align: "center",
      headerAlign: "center",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,
      valueFormatter: (params) => (params.value ? "Active" : "Inactive"),
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params: GridRenderCellParams<ISubjectDriveMap>) => (
        <>
        <IconButtonField
          onClick={() => {
            setInitialValues({ ...params.row });
            setDialogOpen(true);
            setIsEdit(true);
          }}
          disabled={dialogOpen}
        >
          <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
        </IconButtonField>
           <IconButtonField
                      onClick={() => {
                        dispatch(clearSubject_Drive_MapCreate_Update());
                        setDeleteData(params.row); 
                        setDeleteDialogOpen(true);
                      }}
                    >
                      <SvgIcon component={Delete} inheritViewBox />
                    </IconButtonField>
                      </>
      ),
    },
  ];

  const subjectDriveMaps = Array.isArray(subjectDriveMapList?.data)
    ? subjectDriveMapList?.data.map((item, index) => ({
        ...item,
        id: item.booklet_folder_mapping_id,
        index: index + 1,
        subject_name: item.subject?.name ?? "",
      }))
    : [];

  // Fetch data
  useEffect(() => {
    dispatch(Subject_Drive_MapMasterRead());
    setIsEdit(false);
  }, [addOrUpdateResponse, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearSubject_Drive_MapCreate_Update());
    };
  }, []);

  return (
    <>
      <Table rows={subjectDriveMaps ?? []} columns={columns}>
        <CustomToolbar>
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({
                id: "",
                subject_id: 0,
                drive_folder_link: "",
                status: true,
              });
              setDialogOpen(true);
              setIsEdit(false);
            }}
            disabled={dialogOpen}
            toolTip="Add new"
          >
            Add new
          </ButtonField>

          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(Subject_Drive_MapMasterRead())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      {/* Form Dialog */}
      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${(initialValues as Partial<ISubjectDriveMap>).id ? "Update" : "Add"} Subject Drive Map`}
        Dialog_Content={
          <SubjectDriveMapForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
            isEdit={isEdit}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setDialogOpen(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => {
                formRef.current?.requestSubmit();
              }}
            >
              Save
            </ButtonField>
          </>
        }
      />

      <ResponseDialog
        okFunction={() => setDialogOpen(false)}
        response={addOrUpdateResponse}
        parentDialog={setDialogOpen}
      />

       {(deleteDialogData && deleteDialogOpen )&& (
              <DeleteDialog
      
                deleteableName={deleteDialogData.name ?? ""}
                open={deleteDialogOpen}
                setOpen={setDeleteDialogOpen}
                deleteFunction={() => {
                  if (deleteDialogData.id) {
                    dispatch(
                      Subject_Drive_MapCreate_Update({
                        ...deleteDialogData,
                        is_delete: true,
                      })
                    );
                  }
                }}
                response={addOrUpdateResponse}
              />
            )}
    </>
  );
};

export default SubjectDriveMap;
